<template>
  <div class="vouchers__leaderboard">
    <div class="row align-items-center __content_list"
      v-if="isLoadingLeaderboard">
      <half-circle-spinner
        :animation-duration="1500"
        :size="50"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <div v-if="!items || items.length === 0" class="global__nodata" >
        <div class="text-center">
          <h6 class="pt-3">There is No List Leaderboard</h6>
        </div>
      </div>
      <div v-else class="tables__andalinpoint">
        <b-table
          sticky-header="true"
          responsive
          :items="items"
          :fields="fields"
        >
          <template v-slot:head()="scope">
            <div class="text-nowrap table__label">
              <div v-if="scope.label === 'Progress'" class="text-center">
                {{ scope.label }}
              </div>
              <div v-else-if="scope.label === 'Andalin Points'" class="text-right">
                AndalinPoints
              </div>
              <div class="text-nowrap" v-else> {{ scope.label }} </div>
            </div>
          </template>
          <template v-slot:cell(AndalinPoints)="row">
            <div class="text-nowrap text-right">
              {{ row.item.AndalinPoints | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }}
            </div>
          </template>
          <template v-slot:cell(Progress)="row">
            <div class="text-nowrap text-center">
              <img  :src="getProgressImage(row.item.Progress)">
            </div>
          </template>
        </b-table>
        <div class="row m-0 vouchers__leaderboard--footer">
          <div class="col-md-3 pl-0" style="max-width: 185px">
            <p class="fontstyle__default--big">
              <b>My Rank: {{ itemLeaderboard.myRank}}</b>
            </p>
            <p class="fontstyle__infotext--gray">Top 20 Leaderboard</p>
          </div>
          <div class="col-md pl-0">{{ itemLeaderboard.myCompanyName }}</div>
          <div class="col-md pl-0 pr-5 justify-content-end">{{ itemLeaderboard.myPoint | currency('', 0, { spaceBetweenAmountAndSymbol: true }) }}</div>
          <div class="col-md pl-0 justify-content-center" style="max-width: 200px">
            <img  :src="getProgressImage(itemLeaderboard.myTrend)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { HalfCircleSpinner } from 'epic-spinners'
import { mapGetters } from 'vuex'

export default {
  name: 'pointleaderboard',
  components: {
    HalfCircleSpinner
  },
  computed: {
    ...mapGetters({
      itemLeaderboard: 'andalinpoint/itemLeaderboard',
      isLoadingLeaderboard: 'andalinpoint/isLoadingLeaderboard',
      errorLeaderboard: 'andalinpoint/errorLeaderboard',

      redeemPoint: 'andalinpoint/redeemPoint',
      isLoadingredeemPoint: 'andalinpoint/isLoadingredeemPoint',
      errorredeemPoint: 'andalinpoint/errorredeemPoint'
    })
  },
  data () {
    return {
      fields: [
        'Ranking',
        'Company',
        'AndalinPoints',
        'Progress'
      ],
      items: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      await this.getItems()
    },
    getItems (datas) {
      return new Promise((resolve) => {
        this.items = []
        if (this.itemLeaderboard && this.itemLeaderboard.data) {
          this.itemLeaderboard.data.forEach((item) => {
            const newItem = {
              Ranking: `${item.no}.`,
              Company: item.companyName,
              AndalinPoints: item.point,
              Progress: item.trend
            }
            this.items.push(newItem)
          })
          return resolve()
        }
      })
    },
    getProgressImage (progress) {
      let src = ''
      switch (progress) {
        case -1:
          src = require('@/assets/image/icon/leaderboard-progress-down.svg')
          break
        case 0:
          src = require('@/assets/image/icon/leaderboard-progress.svg')
          break
        case 1:
          src = require('@/assets/image/icon/leaderboard-progress-up.svg')
          break
        default:
          src = require('@/assets/image/icon/leaderboard-progress.svg')
          break
      }
      return src
    }
  },
  watch: {
    itemLeaderboard (data) {
      if (data) {
        this.getData()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/andalinpoint/points/Leaderboard.vue